import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import { useTranslate } from '@tolgee/react'
import { TitleWithCaptionCell } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { getReleaseShippingLineInfo } from '../../tableConfigs/releaseTableHelper'

type Props = {
  releaseItem: INumericReleaseItem | INonNumericReleaseItem
}

export const ReleaseOperator = observer(({ releaseItem }: Props) => {
  const { t } = useTranslate()

  const { name, shortName } = getReleaseShippingLineInfo(releaseItem, t)

  return <TitleWithCaptionCell title={name} caption={shortName ?? ''} maxWidth='160px' />
})
